import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import Dropdown from '../Dropdown';
import { useBoundary } from '../Boundary';
import NavbarAccount from './NavbarAccount';
const DISPLAY_NAME = 'NavbarAccountItem';
const Root = styled(NavbarAccount).withConfig({
  displayName: "NavbarAccountItem__Root",
  componentId: "sc-16k1g6w-0"
})([""]);
const NavbarAccountItem = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    isInsideBoundary
  } = useBoundary();
  const isInsideDropdownAnchor = isInsideBoundary(Dropdown.Anchor.displayName);
  return /*#__PURE__*/React.createElement(Root, _extends({}, props, {
    interactive: isInsideDropdownAnchor,
    responsive: true,
    ref: ref
  }));
});
NavbarAccountItem.displayName = DISPLAY_NAME;
NavbarAccountItem.Style = Root;
export default NavbarAccountItem;